import { GeoCoordinates } from 'seo';

export const buildGeoCoordinates = (geoCoordinates: GeoCoordinates) => `
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "${geoCoordinates.latitude}",
    "longitude": "${geoCoordinates.longitude}"
  },
`;
